import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import Heroabout from "./sections/Heroabout";
import CompanyStory from "./sections/CompanyStory";
import Corevalues from "./sections/Corevalues";
import Team from "./sections/Team";
import Statistics from "./sections/Statistics";
import CommercialServices from "./sections/CommercialServices";
import Community from "./sections/Community";
import Reviews from "./sections/Reviews";
import Faq from "./sections/Faq";
import Calltoaction from "./sections/Calltoaction";
export default function AboutUsPage() {
  return <div>
      <Header />
      <Heroabout />
      <CompanyStory />
      <Corevalues />
      <Team />
      <Statistics />
      <CommercialServices />
      <Community />
      <Reviews />
      <Faq />
      <Calltoaction />
    </div>;
}